import { fieldHoursType, fieldHoursTypeFullName } from "../types/index.const";

const fieldServiceHoursOptions = fieldHoursType.map((el, index) => ({
  label: fieldHoursTypeFullName[index],
  value: el,
}));

export default fieldServiceHoursOptions;
